import { deepMerge } from 'js/utils/Utils'

const defaults = {
  $names: {
    jaLink: '.g-header_list-lang_link.-ja',
    enLink: '.g-header_list-lang_link.-en',
  },
  jaHome: '/',
  enHome: '/en/',
}

export default class LangSwitcher {
  $jaLink = null
  $enLink = null
  cache = new Map()

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.update()
  }

  pageEnter() {
    this.update()
  }

  _set$() {
    this.$jaLink = document.querySelector(this.$names.jaLink)
    this.$enLink = document.querySelector(this.$names.enLink)
  }

  async update() {
    if (!this.$jaLink && !this.$enLink) return

    const pathname = window.location.pathname
    const isEnglish = /^\/en(\/|$)/.test(pathname)
    const { jaPath, enPath } = this._getCounterpartPaths(pathname)

    const jaHrefPromise = isEnglish
      ? this._resolve(jaPath, this.jaHome)
      : Promise.resolve(jaPath)
    const enHrefPromise = isEnglish
      ? Promise.resolve(enPath)
      : this._resolve(enPath, this.enHome)

    const [jaHref, enHref] = await Promise.all([jaHrefPromise, enHrefPromise])

    if (this.$jaLink) this.$jaLink.href = jaHref
    if (this.$enLink) this.$enLink.href = enHref
  }

  _getCounterpartPaths(pathname) {
    let path = pathname.replace(/index\.html$/, '')
    if (!path.endsWith('/')) path += '/'

    let jaPath
    let enPath
    if (path === '/en/' || path.startsWith('/en/')) {
      jaPath = path.replace(/^\/en/, '') || '/'
      if (jaPath === '') jaPath = '/'
      enPath = path
    } else {
      jaPath = path
      enPath = path === '/' ? '/en/' : `/en${path}`
    }
    return { jaPath, enPath }
  }

  async _resolve(path, fallback) {
    if (this.cache.has(path)) {
      return this.cache.get(path) ? path : fallback
    }
    try {
      const res = await fetch(path, { method: 'HEAD' })
      const exists = res.ok
      this.cache.set(path, exists)
      return exists ? path : fallback
    } catch {
      return fallback
    }
  }
}
